import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LoginPageGuard } from './guards/login-page.guard';
import { OAuthCallback } from './ui/auth/oauth-callback/oauth-callback';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./routes/web.routes').then((m) => m.webRoutes),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./routes/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: 'internal',
    canActivate: [AuthGuard],
    loadChildren: () => import('./routes/internal.routes').then((m) => m.internalRoutes),
  },
  {
    path: 'login',
    canActivate: [LoginPageGuard],
    loadChildren: () => import('./routes/auth.routes').then((m) => m.authRoutes),
  },
  { path: 'oauth-callback', component: OAuthCallback, data: { provider: 'rba' } },
  { path: 'ht-oauth-callback', component: OAuthCallback, data: { provider: 'ht' } },
  { path: 'callback-telemachhr', component: OAuthCallback, data: { provider: 'telemachhr' } },
  { path: ':misstypedPath', redirectTo: '' },
];
